import { ProjectViewer } from 'modules/Project/views/ProjectViewer/ProjectViewer';

export default ProjectViewer;
